import router from '../router'
import axios from 'axios'
import toastr from 'toastr/toastr'
import Vue from 'vue'
import Vuex from 'vuex'

axios.interceptors.request.use(function (config) {
    // Do something before request is sen
    if(localStorage.getItem('hash')){
        config.data.userHash = localStorage.getItem('hash')
    }
    return config;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    if(response.status == 204){
        localStorage.removeItem('hash')
        router.push('/')
        let lang = localStorage.getItem('lang')
        switch (lang){
            case 'ru':
                toastr.warning('Время сессии истекло!')
                return response;
            case 'en':
                toastr.warning('Time of session is over!')
                return response
            case 'az':
                toastr.warning('Müəyyən edilmiş vaxt bitib!')
                return response
        }
    }

    return response;
}, function (error) {
    console.log(error);
    let lang = localStorage.getItem('lang')
    switch (lang){
        case 'ru':
            toastr.warning('Время сессии истекло!')
            return error;
        case 'en':
            toastr.warning('Time of session is over!')
            return error
        case 'az':
            toastr.warning('Müəyyən edilmiş vaxt bitib!')
            return error
    }
    return Promise.reject(error);
});


export default axios;